// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"27ac2775","345":"be23bf22","380":"f7a3046c","552":"1bf1ea39","599":"dae757db","652":"7f8948b8","706":"db87a7b0","764":"395be20e","831":"63ca761c"}[chunkId] + ".chunk.js";
};